<template>
  <div class="footer-component">
    <div class="content">
      <div class="footer-main">
        <div class="logo-area">
          <div class="logo">
            <img src="@/assets/imgs/logo-shiyuan.png" alt="logo">
          </div>
          <p>以创新改变世界，以元力开启未来</p>
        </div>
        <div class="links-area">
          <ul>
            <li>
              <a href="http://user.yishangji.com.cn/" target="_blank" rel="noopener noreferrer">易商机</a>
            </li>
            <li>
              <a href="http://agent.yishangji.com.cn/" target="_blank" rel="noopener noreferrer">易商合伙人</a>
            </li>
          </ul>
          <ul>
            <li><a href="/dock">产业服务</a></li>
            <li><a href="/digitize">科技服务</a></li>
            <li><a href="/incubation">孵化服务</a></li>
            <li><a href="/parlor">产业会客厅</a></li>
            <li><a href="/policy">产业政策</a></li>
            <li><a href="/news">产业动态</a></li>
          </ul>
        </div>
      </div>
      
      <div class="contact-section">
        <div class="contact-item item-1">
          <div class="icon">
            <i class="el-icon-phone"></i>
          </div>
          <div class="info">
            <div class="label">Phone</div>
            <div class="value">19291076247</div>
          </div>
        </div>
        <div class="contact-item item-2">
          <div class="icon">
            <i class="el-icon-location-outline"></i>
          </div>
          <div class="info">
            <div class="label">Location</div>
            <div class="value">北京市海淀区中关村软件园2号楼A座</div>
          </div>
        </div>
        <div class="contact-item item-3">
          <div class="icon">
            <i class="el-icon-message"></i>
          </div>
          <div class="info">
            <div class="label">Email</div>
            <div class="value">shiyuan@163.com</div>
          </div>
        </div>
      </div>
      
      <div class="beian">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          京ICP备19042125号-6
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
}
</script>

<style scoped lang="scss">
.footer-component {
  background: linear-gradient( 135deg, #00008E 0%, #017280 100%);
  color: #fff;
  padding: 60px 0 30px;
  width: 100%;
  margin: 0 auto;

  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }

  .footer-main {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
  }

  .logo-area {
    width: 35%;
    .logo {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      img {
        height: 40px;
        margin-right: 10px;
      }
      span {
        font-size: 24px;
        font-weight: bold;
      }
    }
    p {
      font-size: 20px;
color: #E1E1E1;
line-height: 25px;
      max-width: 380px;
    }
  }

  .links-area {
    margin-top: 40px;
    margin-right: 86px;
    display: flex;
    gap: 80px;
    ul {
      list-style: none;
      padding: 0;
      li {
        margin-bottom: 25px;
        position: relative;
        padding-left: 15px;
        &::before {
          content: '›';
          position: absolute;
          left: 0;
          top: 0;
          color: #fff;
          font-size: 16px;
        }
        a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 22px;
          transition: color 0.3s;
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  .contact-section {
    display: flex;
    justify-content: space-between;
    padding: 40px 0;
    margin-bottom: 40px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .contact-item {
    width: 393px;
    height: 139px;
    background: rgba(255,255,255,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.item-2 {
      background: rgba(255,255,255,0.2);
    }
    
    .icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      i {
        font-size: 50px;
        color: #fff;
      }
    }
    .info {
      .label {
        font-size: 17px;
color: #E1E1E1;
line-height: 25px;
        margin-bottom: 4px;
      }
      .value {
        font-weight: bold;
font-size: 18px;
color: #FFFFFF;
line-height: 24px;
        color: #fff;
      }
    }
  }

  .copyright {
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }

  .beian {
    text-align: center;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 24px;
    padding-top: 16px;
    letter-spacing: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);

    a {
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      transition: color 0.3s;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>